import { createContext } from 'react';
import { IServiceTransferReportDto, IServiceTransferReportsDto } from '@shared/api';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { IsoReportType } from '../';

export interface IISOReportTableContext {
    date: null | string;
    isoReports: IServiceTransferReportsDto[];
    isoReportsLoading: boolean;
    paginationOptions: PaginationOptions | null;
    isoReportsType: IsoReportType;
    onISOReportViewClick: (isoReport: IServiceTransferReportDto) => void;
    setDate: (date: string | null) => void;
    setISOReportsType: (type: IsoReportType) => void;
}

export const ISOReportsTableContext = createContext<IISOReportTableContext>({
    date: null,
    isoReports: [],
    isoReportsLoading: false,
    paginationOptions: null,
    isoReportsType: 'current',
    onISOReportViewClick: emptyFunc,
    setDate: emptyFunc,
    setISOReportsType: emptyFunc,
});
